import React from 'react';
import OceanLabel from './../../images/ocean-label.png';
import {Fade} from 'react-reveal';

function HomeTitle(){
  return (
    <section className="home-title text-center">
      {/* <h1 className="site-heading">Ocean and Dexter's Kitchen</h1> */}
      <Fade duration={2500}>
      <img src={OceanLabel} className="ocean-label" alt="Ocean and Dexter's Kitchen"/>
      </Fade>
      <br />
      <a href="#home-recipes"><i id="title-down-button" className="fas fa-chevron-circle-down"></i></a>
    </section>
  )
}

export default HomeTitle;